import { createSlice } from '@reduxjs/toolkit';
const initialState = {};
export const zigbeeDeviceInfoSlice = createSlice({
    name: 'zigbee_device_info',
    initialState,
    reducers: {
        zigbeeDeviceInfosCleared: s => {
            for (const key in s) {
                delete s[key];
            }
        },
        zigbeeDeviceInfoUpdated: (s, action) => {
            s[action.payload.id] = action.payload.device_info;
        },
        zigbeeDeviceInfoDeleted: (s, action) => {
            delete s[action.payload];
        },
    }
});
export const { zigbeeDeviceInfosCleared, zigbeeDeviceInfoUpdated, zigbeeDeviceInfoDeleted } = zigbeeDeviceInfoSlice.actions;
export default zigbeeDeviceInfoSlice.reducer;
